// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"ede72849","828":"47a00926"}[chunkId] + ".chunk.js";
};